import { useEffect, useRef, useState } from "react";

function useRevealOnScroll(ref) {
  useEffect(() => {
    const elements = ref.current?.querySelectorAll("[data-reveal]");
    if (!elements) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target;
            const delay = el.dataset.delay || "0";
            setTimeout(() => {
              el.style.opacity = "1";
              el.style.transform = "translateY(0)";
            }, parseFloat(delay));
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 },
    );

    elements.forEach((el) => {
      el.style.opacity = "0";
      el.style.transform = "translateY(20px)";
      el.style.transition = "opacity 0.75s ease, transform 0.75s ease";
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);
}

// ─── Update these with your real links ──────────────────────────────────
const socials = [
  {
    name: "Instagram",
    href: "https://instagram.com/noahdecoco",
    label: "@noahdecoco",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        className="w-5 h-5"
      >
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    name: "WhatsApp",
    href: "https://wa.me/31631958895",
    label: "Message on WhatsApp",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>
    ),
  },
  {
    name: "YouTube",
    href: "https://youtube.com/@safe-and-sound-journeys",
    label: "Watch on YouTube",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
  {
    name: "Spotify",
    href: "https://open.spotify.com/artist/5p3IIXsYQPHxCrtggdRAJ6",
    label: "Listen on Spotify",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" />
      </svg>
    ),
  },
];
// ────────────────────────────────────────────────────────────────────────

const inputBase =
  "w-full px-4 py-3.5 bg-cream border border-sand-dark font-jost font-light text-ink placeholder:text-stone/40 text-[0.92rem] outline-none focus:border-earth transition-colors duration-300";

export const ConnectContent = () => {
  const sectionRef = useRef(null);
  useRevealOnScroll(sectionRef);

  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    interest: "",
    message: "",
  });

  function handleChange(e) {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    // Replace with your real form handler — Formspree, EmailJS, etc.
    console.log("Form submitted:", form);
    setSubmitted(true);
  }

  return (
    <section
      id="contact"
      ref={sectionRef}
      className="bg-sand py-24 lg:py-32 px-8 lg:px-16"
    >
      <div className="max-w-7xl mx-auto">
        {/* ── Closing statement ── */}
        <div data-reveal data-delay="0" className="mb-20 lg:mb-24 max-w-2xl">
          <p className="font-jost font-light text-[0.65rem] tracking-[0.3em] uppercase text-earth-light mb-5">
            Let's connect
          </p>
          <h2
            className="font-cormorant font-light text-ink leading-[1.1] mb-8"
            style={{ fontSize: "clamp(2.4rem, 4vw, 4rem)" }}
          >
            The right space
            <br />
            <em className="italic text-earth">begins with a conversation.</em>
          </h2>
          <div className="w-10 h-px bg-earth-light/50 mb-8" />
          <p
            className="font-jost font-light text-stone leading-[1.9]"
            style={{ fontSize: "clamp(0.9rem, 1.05vw, 1rem)" }}
          >
            Whether you're ready to book or just curious, reach out. There's no
            pressure and no script. Just tell me what's going on for you — and
            we'll find out together whether this work is the right fit.
          </p>
        </div>

        {/* ── Two column layout ── */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
          {/* ── Left: form ── */}
          <div data-reveal data-delay="100">
            {submitted ? (
              <div className="flex flex-col justify-center h-full py-12">
                <div className="w-10 h-px bg-earth-light/50 mb-8" />
                <h3 className="font-cormorant italic font-light text-ink text-3xl mb-4">
                  Thank you.
                </h3>
                <p className="font-jost font-light text-stone leading-relaxed">
                  I'll be in touch within a day or two. In the meantime, feel
                  free to listen to the music — let it settle in.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="flex flex-col gap-1.5">
                    <label className="font-jost font-light text-[0.63rem] tracking-[0.2em] uppercase text-earth/70">
                      Your name
                    </label>
                    <input
                      type="text"
                      name="name"
                      required
                      placeholder="How should I call you?"
                      value={form.name}
                      onChange={handleChange}
                      className={inputBase}
                    />
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <label className="font-jost font-light text-[0.63rem] tracking-[0.2em] uppercase text-earth/70">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="your@email.com"
                      value={form.email}
                      onChange={handleChange}
                      className={inputBase}
                    />
                  </div>
                </div>

                <div className="flex flex-col gap-1.5">
                  <label className="font-jost font-light text-[0.63rem] tracking-[0.2em] uppercase text-earth/70">
                    I'm interested in
                  </label>
                  <select
                    name="interest"
                    value={form.interest}
                    onChange={handleChange}
                    className={`${inputBase} appearance-none cursor-pointer`}
                  >
                    <option value="" disabled>
                      Choose what resonates...
                    </option>
                    <option value="single">Single sound healing session</option>
                    <option value="package">4–6 session package</option>
                    <option value="group">Group ceremony</option>
                    <option value="ceremony-music">
                      Music for a ceremony or retreat
                    </option>
                    <option value="other">Something else</option>
                  </select>
                </div>

                <div className="flex flex-col gap-1.5">
                  <label className="font-jost font-light text-[0.63rem] tracking-[0.2em] uppercase text-earth/70">
                    What's going on for you?
                  </label>
                  <textarea
                    name="message"
                    rows={5}
                    placeholder="Share as much or as little as feels right..."
                    value={form.message}
                    onChange={handleChange}
                    className={`${inputBase} resize-none`}
                  />
                </div>

                <button
                  type="submit"
                  className="self-start mt-2 px-8 py-3.5 bg-ink text-cream font-jost font-light text-[0.72rem] tracking-[0.18em] uppercase transition-all duration-300 hover:bg-earth border border-ink hover:border-earth"
                >
                  Send a message
                </button>
              </form>
            )}
          </div>

          {/* ── Right: info + socials ── */}
          <div
            data-reveal
            data-delay="200"
            className="flex flex-col justify-between gap-12"
          >
            {/* Location & availability */}
            <div>
              <p className="font-jost font-light text-[0.63rem] tracking-[0.2em] uppercase text-earth/70 mb-5">
                Location & availability
              </p>
              <div className="space-y-4">
                {[
                  {
                    place: "Amsterdam, Netherlands",
                    note: "In-person sessions available",
                  },
                  {
                    place: "Online sessions",
                    note: "Available internationally",
                  },
                  {
                    place: "Ceremonies & retreats",
                    note: "Netherlands & travelling — enquire for availability",
                  },
                ].map((item) => (
                  <div key={item.place} className="flex items-start gap-4">
                    <div className="w-px h-12 bg-earth-light/40 flex-shrink-0 mt-1" />
                    <div>
                      <p className="font-cormorant font-light text-ink text-lg mb-0.5">
                        {item.place}
                      </p>
                      <p className="font-jost font-light text-stone text-sm">
                        {item.note}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Email direct */}
            <div>
              <p className="font-jost font-light text-[0.63rem] tracking-[0.2em] uppercase text-earth/70 mb-4">
                Or reach out directly
              </p>
              <a
                href="mailto:hello@noahfernandes.com"
                className="font-cormorant italic font-light text-earth hover:text-ink transition-colors duration-300"
                style={{ fontSize: "clamp(1.1rem, 1.4vw, 1.3rem)" }}
              >
                hello@noahfernandes.com
              </a>
            </div>

            {/* Social links */}
            <div>
              <p className="font-jost font-light text-[0.63rem] tracking-[0.2em] uppercase text-earth/70 mb-5">
                Follow the work
              </p>
              <div className="flex flex-col gap-3">
                {socials.map((s) => (
                  <a
                    key={s.name}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-4 group"
                  >
                    <span className="text-stone group-hover:text-earth transition-colors duration-300">
                      {s.icon}
                    </span>
                    <span className="font-jost font-light text-stone text-sm group-hover:text-ink transition-colors duration-300">
                      {s.label}
                    </span>
                    <span className="text-stone/30 group-hover:text-earth transition-colors duration-300 text-xs ml-auto">
                      ↗
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ── Footer strip ── */}
        <div
          data-reveal
          data-delay="400"
          className="mt-20 pt-8 border-t border-sand-dark flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4"
        >
          <p className="font-cormorant italic font-light text-stone text-lg">
            Noah Fernandes
          </p>
          <p className="font-jost font-light text-stone/50 text-[0.7rem] tracking-wide">
            Goa &nbsp;·&nbsp; Amsterdam &nbsp;·&nbsp; Present wherever needed
          </p>
        </div>
      </div>
    </section>
  );
};
